import {requirementsFields} from "../../system-settings/service-requirements/service-requirement.graphql";
import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";


export const serviceManagementRequirementFields = `
id
serviceRequirementUniqueId
requirementIsMandatory
descriptions
alternativesRequirements {
  id
  serviceRequirementUniqueId
  requirementIsMandatory
  descriptions
  requirement {
    requirementName
  }
}
requirement {
  ${requirementsFields}
}
`

export const CREATE_SERVICE_MANAGEMENT_REQUIREMENT = gql`
  mutation AddServiceRequirementsMutation($input: ServiceRequirementsInputObjects!) {
    addServiceRequirementsMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${serviceManagementRequirementFields}
      }
    }
  }
`


export const UPDATE_SERVICE_REQUIREMENT_DESCRIPTION = gql`
  mutation UpdateRequirementsDescriptionsMutation($input: RequirementsDescriptionInputObjects!) {
    updateRequirementsDescriptionsMutation(input: $input) {
      data{
        ${serviceManagementRequirementFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;


export const ADD_SERVICE_REQUIREMENT_ALTERNATIVE = gql`
  mutation AddAltenativeRequirementsMutation($input: AltenativeRequirementsInputObject!) {
    addAltenativeRequirementsMutation(input: $input) {
      data{
        ${serviceManagementRequirementFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;


export const REMOVE_SERVICE_REQUIREMENT_ALTERNATIVE = gql`
  mutation RemoveAltenativeRequirementsMutation($requirementUniqueId: String!) {
    removeAltenativeRequirementsMutation(requirementUniqueId: $requirementUniqueId) {
      data{
        ${serviceManagementRequirementFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;


export const DELETE_SERVICE_MANAGEMENT_REQUIREMENT = gql`
  mutation RemoveServiceRequirementsMutation($serviceRequirementUniqueId: String) {
    removeServiceRequirementsMutation(serviceRequirementUniqueId: $serviceRequirementUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`

export const GET_SERVICE_MANAGEMENT_REQUIREMENT = gql`
  query GetInstitutionServicesRequirements($serviceUniqueId: String) {
    getInstitutionServicesRequirements(serviceUniqueId: $serviceUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${serviceManagementRequirementFields}
      }
    }
  }
`


